import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import cx from 'classnames';
import { Grid } from 'semantic-ui-react';

const TextWithBlocksView = (props) => {
  const { data, path, className, style } = props;
  const metadata = props.metadata || props.properties;

  if (data.blocks_layout === undefined) {
    return null;
  }

  const columns = data.blocks_layout.items;
  const blocksConfig =
    config.blocks.blocksConfig[data['@type']]?.blocksConfig ||
    props.blocksConfig;
  const location = { pathname: path };

  let buttonHref;
  if (data.buttonLink?.length > 0) {
    const link = data.buttonLink[0];
    buttonHref = link?.['@id'] || link;
  }

  return (
    <div className={cx('block text-with-blocks', className)} style={style}>
      {/* Top text section */}
      <div className="text-with-blocks-box">
        <div className="text-with-blocks-header">
          {data.headline && (
            <h2 className="text-with-blocks-headline">{data.headline}</h2>
          )}
          {data.text && (
            <div
              className="text-with-blocks-text"
              dangerouslySetInnerHTML={{ __html: data.text.data }}
            />
          )}
        </div>

        {/* Grid section */}
        <Grid
          stackable
          stretched
          columns={columns.length}
          className={cx('text-with-blocks-grid', {
            one: columns?.length === 1,
            two: columns?.length === 2,
            three: columns?.length === 3,
            four: columns?.length === 4,
          })}
        >
          <RenderBlocks
            {...props}
            blockWrapperTag={Grid.Column}
            metadata={metadata}
            content={data}
            location={location}
            blocksConfig={blocksConfig}
            isContainer
          />
        </Grid>

        {/* Bottom button */}
        {data.buttonLabel && (
          <div className="text-with-blocks-button-wrapper">
            {buttonHref ? (
              <UniversalLink
                href={
                  isInternalURL(buttonHref)
                    ? flattenToAppURL(buttonHref)
                    : buttonHref
                }
                className="text-with-blocks-button"
              >
                {data.buttonLabel}
              </UniversalLink>
            ) : (
              <span className="text-with-blocks-button">
                {data.buttonLabel}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default withBlockExtensions(TextWithBlocksView);
